module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.scss
// module id = ./web/modern/components/quotes/modals/save-new-template-modal/save-new-template-modal.component.scss
// module chunks = 0